import { SxProps, Theme } from '@mui/material';
import {
  BRAND_NAVY, CHART_UI, MOTION, NOW_LINE, PEAK_HOUR, RADIUS,
} from './dashboardColors';
import type { StatusPalette } from './riego.types';
import { SWATCH_SIZE } from './riego.constants';

export const paperSx: SxProps<Theme> = {
  p: 2.5,
  mb: 3,
  border: `1px solid ${CHART_UI.paperBorder}`,
  borderRadius: RADIUS.card,
  bgcolor: CHART_UI.paperBackground,
  boxShadow: CHART_UI.paperShadow,
};

export const surfaceSx: SxProps<Theme> = {
  border: `1px solid ${CHART_UI.paperBorder}`,
  borderRadius: RADIUS.card,
  bgcolor: CHART_UI.paperBackground,
  boxShadow: CHART_UI.paperShadow,
};

// Press feedback for any clickable control; degrades under reduced motion.
export const pressableSx: SxProps<Theme> = {
  borderRadius: RADIUS.control,
  transition: `transform ${MOTION.fast} ${MOTION.ease}, box-shadow ${MOTION.base} ${MOTION.ease}`,
  '&:active': { transform: 'scale(0.97)' },
  '@media (prefers-reduced-motion: reduce)': {
    transition: 'none',
    '&:active': { transform: 'none' },
  },
};

// Bold label variant of pressableSx, used by the dashboard header's quick actions.
export const boldPressableSx: SxProps<Theme> = { fontWeight: 700, ...pressableSx };

export const peakChipSx: SxProps<Theme> = {
  fontWeight: 600,
  color: PEAK_HOUR.text,
  borderColor: PEAK_HOUR.border,
};

export const peakHourSwatchSx: SxProps<Theme> = {
  width: SWATCH_SIZE,
  height: SWATCH_SIZE,
  bgcolor: PEAK_HOUR.swatchFill,
  border: `1px dashed ${PEAK_HOUR.border}`,
  borderRadius: '50%',
};

export const headerStackSx: SxProps<Theme> = { flexWrap: 'wrap', gap: 1.5 };

export const accentBarSx: SxProps<Theme> = {
  width: 4, height: 28, bgcolor: BRAND_NAVY, borderRadius: 1,
};

export const pumpNameSx: SxProps<Theme> = { fontWeight: 700, color: BRAND_NAVY };

export const zonesChipSx: SxProps<Theme> = { bgcolor: CHART_UI.chipBackground };

export const legendStackSx: SxProps<Theme> = { pl: 1, flexWrap: 'wrap', gap: 2 };

export const legendSwatchSx = (
  palette: StatusPalette,
  showBorder?: boolean,
  swatch?: string,
): SxProps<Theme> => ({
  width: SWATCH_SIZE,
  height: SWATCH_SIZE,
  bgcolor: swatch || palette.fill,
  border: showBorder ? `1px ${palette.dashed ? 'dashed' : 'solid'} ${palette.border}` : 'none',
  borderRadius: '50%',
});

export const nowLineSwatchSx: SxProps<Theme> = {
  width: 2, height: SWATCH_SIZE, bgcolor: NOW_LINE,
};
